import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Ticker from "../components/Ticker";
import Levels from "../components/Levels";
import CambridgeExams from "../components/CambridgeExams";
import Method from "../components/Method";
import Platform from "../components/Platform";
import Age from "../components/Age";
import Testimonial from "../components/Testimonial";
import Plans from "../components/Plans";
import Benefits from "../components/Benefits";
import FinalCTA from "../components/FinalCTA";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/WhatsAppFloat";
import { TrialPromoBlock, TrialPromoStrip } from "../components/TrialPromo";

const Home = () => {
  useEffect(() => {
    document.title = "ActiveEnglish — Cursos de Inglés Online 100% E-learning";
    const els = document.querySelectorAll(".fade-in, .img-zoom-wrap");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("in-view");
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <>
      <Navbar />
      <Hero />
      <Ticker />
      <TrialPromoBlock />
      <Levels />
      <CambridgeExams />
      <Method />
      <Platform />
      <TrialPromoStrip />
      <Age />
      <Testimonial />
      <Plans />
      <Benefits />
      <TrialPromoBlock compact />
      <FinalCTA />
      <Contact />
      <Footer />
      <WhatsAppFloat />
    </>
  );
};

export default Home;
